import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import de from "./locales/de.json";
import sl from "./locales/sl.json";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "en", // Default, bis der Server antwortet
  fallbackLocale: "en", // fehlende Keys fallen auf Englisch zurück
  messages: { en, de, sl },
  silentTranslationWarn: true
});
